import easyfyAxios from '@shared/easyfy.axios';

export const GetNotifyMeFlyout = async (searchProductId: string): Promise<any> => {
  return await easyfyAxios.get(`/api/notifymeflyout?searchProductId=${encodeURIComponent(searchProductId)}`);
};
